"use strict";
/* eslint-disable react/jsx-no-bind */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingFieldEditor = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_hook_form_1 = require("react-hook-form");
const CreateOutlined_1 = __importDefault(require("@material-ui/icons/CreateOutlined"));
const SettingFieldEditor = (props) => {
    const { label, value, fields, description, defaultValues, handleValueChange } = props;
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [isProcessing, setIsProcessing] = react_1.useState(false);
    const { handleSubmit, register } = react_hook_form_1.useForm({ defaultValues });
    const submit = async (e) => {
        setIsProcessing(true);
        await handleSubmit(async (data) => {
            if (handleValueChange) {
                await handleValueChange(data);
            }
            setIsOpen(false);
            setIsProcessing(false);
        })(e);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Dialog, { open: isOpen, onClose: () => setIsOpen(false), disableBackdropClick: true, disableEscapeKeyDown: true, maxWidth: "xs", fullWidth: true },
            react_1.default.createElement(core_1.DialogTitle, null,
                "Edit ",
                label),
            react_1.default.createElement(core_1.DialogContent, { dividers: true },
                description && react_1.default.createElement(core_1.DialogContentText, null, description),
                react_1.default.createElement("form", { onSubmit: submit }, fields.map((f) => (react_1.default.createElement("p", { key: f.key },
                    react_1.default.createElement(core_1.TextField, { label: f.label, name: f.key, inputRef: register, fullWidth: true, disabled: isProcessing })))))),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: () => setIsOpen(false), color: "primary", disabled: isProcessing }, "Cancel"),
                react_1.default.createElement(core_1.Button, { onClick: submit, color: "primary", disabled: isProcessing }, "Save")),
            react_1.default.createElement(core_1.LinearProgress, { style: { visibility: isProcessing ? 'inherit' : 'hidden' } })),
        react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "center", onClick: () => setIsOpen(true), style: { cursor: 'pointer' } },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { display: "block", variant: "caption", color: "textSecondary" }, label),
                react_1.default.createElement(core_1.Typography, { display: "block" }, value)),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.IconButton, { onClick: () => setIsOpen(true) },
                    react_1.default.createElement(CreateOutlined_1.default, null))))));
};
exports.SettingFieldEditor = SettingFieldEditor;
//# sourceMappingURL=index.js.map